// dashboard/widgets/MiniLineChart.js
// Weight pop-out's small trend chart. Extracted from App.js (2026-08-12 split).

import i18n from '../../i18n';
import { c } from '../constants';

export default function MiniLineChart({ points, lineColor }) {
  if (!points || points.length < 2) return null;
  const W = 352, H = 80;
  const pad = { t: 8, r: 8, b: 22, l: 32 };
  const cW = W - pad.l - pad.r, cH = H - pad.t - pad.b;
  const ts = points.map(p => p.t);
  const vs = points.map(p => p.v);
  const tMin = Math.min(...ts), tMax = Math.max(...ts), tR = tMax - tMin || 1;
  const vMin = Math.min(...vs) - 0.5, vMax = Math.max(...vs) + 0.5, vR = vMax - vMin || 1;
  const xP = t => pad.l + ((t - tMin) / tR) * cW;
  const yP = v => pad.t + (1 - (v - vMin) / vR) * cH;
  const linePts = points.map(p => `${xP(p.t)},${yP(p.v)}`).join(' ');
  const fillPts = [`${xP(tMin)},${pad.t + cH}`, ...points.map(p => `${xP(p.t)},${yP(p.v)}`), `${xP(tMax)},${pad.t + cH}`].join(' ');
  const fmtX = ts => new Date(ts).toLocaleString(i18n.language, { month: 'short', day: 'numeric' });
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display: 'block', marginBottom: 12 }}>
      <rect x={pad.l} y={pad.t} width={cW} height={cH} fill={c.fog} rx="3" />
      <text x={pad.l - 4} y={pad.t + 4}      textAnchor="end"   fontSize="8" fill={c.textSoft} style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>{vMax.toFixed(1)}</text>
      <text x={pad.l - 4} y={pad.t + cH + 4} textAnchor="end"   fontSize="8" fill={c.textSoft} style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>{vMin.toFixed(1)}</text>
      <polygon points={fillPts} fill={lineColor} opacity="0.08" />
      <polyline points={linePts} fill="none" stroke={lineColor} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      {points.map((p, i) => <circle key={i} cx={xP(p.t)} cy={yP(p.v)} r="3" fill={c.white} stroke={lineColor} strokeWidth="1.5" />)}
      <text x={xP(tMin)} y={H - 4} textAnchor="start" fontSize="8" fill={c.textSoft} style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>{fmtX(tMin)}</text>
      <text x={xP(tMax)} y={H - 4} textAnchor="end"   fontSize="8" fill={c.textSoft} style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>{fmtX(tMax)}</text>
    </svg>
  );
}
